// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"7523":"b5f2d841a7378446ec09","9702":"6efcadbbba34a2bb59a6"}[chunkId] + ".css";
};